import React, { FormEvent, useContext, useMemo, useState } from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import set from 'lodash/set';

import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import Textarea from 'src/presentation/components/forms/Textarea';
import FormContext from 'src/presentation/contexts/FormContext';
import { typeSpecJSON } from './helpers';

type JsonTextEditorProps = {
  attr: string;
  typeSpec: TypeSpec;
};

const JsonTextEditor = ({ attr, typeSpec }: JsonTextEditorProps) => {
  const { workingState, onBlur } = useContext(FormContext);

  const value = useMemo(() => {
    let value = get(workingState, attr);

    if (isNil(value)) {
      value = typeSpecJSON(typeSpec);
    }

    return value;
  }, [attr, typeSpec, workingState]);

  const [val, setVal] = useState(value);

  const handleChange = (e: FormEvent<HTMLInputElement>) => {
    const value = (e.target as HTMLInputElement).value;

    let formattedValue = value;
    try {
      formattedValue = JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      formattedValue = value;
    }

    const newProps = { currentState: set({}, attr, formattedValue) };

    onBlur && onBlur(newProps);
    setVal(value);
  };

  return <Textarea attr={attr} value={val} onChange={handleChange} />;
};

export default JsonTextEditor;
